exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".suffix[data-v-02812b29]{margin-top:-0.07813rem;padding:0 0.02083rem;height:0.15625rem;line-height:0.15625rem;color:#a6a6a6;position:absolute;top:50%;right:0;z-index:10}\n", ""]);

// exports
